import { createSlice } from '@reduxjs/toolkit';
import { getToken, getUser } from '../../services/authService';

const token = getToken();
const user = getUser();
const initialState = {
    user: user,
    isAuthenticated: token ? true : false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        LOGIN: (state, action) => {
            return {
                ...state,
                user: action.payload?.user,
                isAuthenticated: true,
            };
        },
        LOGOUT: (state, action) => {
            return {
                user: '',
                isAuthenticated: false,
            };
        },
    },
});

export const { LOGIN, LOGOUT } = authSlice.actions;

export default authSlice.reducer;
